


































import Vue from 'vue';
import { mapGetters } from 'vuex';
import { Component, Prop } from 'vue-property-decorator';
import AddNotificationHook from './AddNotificationHook.vue';

@Component({
    computed: {
        ...mapGetters('bh-notification-templates', { getNotificationTemplate: 'get' })
    },
    components: {
        AddNotificationHook
    }
})
export default class NotificationHooksManager extends Vue {
    getNotificationTemplate: any;

    successMessage = false;
    error = {
        show: false,
        message: ''
    };

    // Data
    search = '';
    headers = [
        {
            text: 'ID',
            align: 'start',
            sortable: false,
            value: 'id',
        },
        {
            text: 'Target Template',
            align: 'start',
            sortable: false,
            value: 'nt_id',
        },
        {
            text: 'Service Name',
            align: 'start',
            sortable: false,
            value: 'service',
        },
        {
            text: 'Service Method',
            align: 'end',
            sortable: false,
            value: 'method',
        },
        {
            text: 'Record Incomming Data',
            align: 'end',
            sortable: false,
            value: 'enable_record'
        },
        {
            text: 'Actions',
            align: 'end',
            value: 'data-table-expand'
        }
    ]
    query = { /*id: { $nin: [this.user.id] }*/ };
    pagination = {
        page: 1,
        itemsPerPage: 10,
        sortBy: [],
        sortDesc: []
    };

    public get fetchQuery() {
        return Object.assign({}, {
            ...this.query,
            // ...this.extendedQuery,
            $populate: true
        }, {
            // ...this.searchQuery,
            $limit: this.pagination.itemsPerPage,
            $skip: (this.pagination.page-1) * this.pagination.itemsPerPage,
            ...this.sortingQuery
        });
    }

    public get dataQuery() {
        return {
            ...this.query,
            // ...this.extendedQuery,
            // ...this.searchDataQuery,
            $limit: this.pagination.itemsPerPage,
            $skip: (this.pagination.page-1) * this.pagination.itemsPerPage,
            ...this.sortingQuery
        };
    }

    public get sortingQuery() {
        if(this.pagination.sortBy.length !== 0) {
            const $sort: any = {};
            this.pagination.sortBy.map((item, index) => {
                switch(item) {
                    default:
                        $sort[item] = this.pagination.sortDesc[index] ? -1 : 1;
                }
                
            });
            return { $sort };
        }
        return null;
    }

    public onError(err: any) {
        this.error.show = true;
        this.error.message = err.message;
    }

    public displayTemplateName(id: number) {
        return this.getNotificationTemplate(id) || {
            target_type: 'NULL'
        };
    }

}
